import { Promises } from "./promises";
import { Errors, isInstanceOf } from "@opendaw/lib-std";
export var network;
(function (network) {
    const limit = new Promises.Limit(4);
    network.limitFetch = (input, init) => limit.add(() => fetch(input, init));
    network.DefaultRetry = (reason, count) => {
        return !isInstanceOf(reason, Errors.FileNotFound) || count <= 100;
    };
})(network || (network = {}));
